module.exports = __webpack_public_path__ + "img/kone-lift-md.b3b9489e.svg";